import React, { useEffect } from "react"
import { Col, Row } from "reactstrap"
import { Field, change } from "redux-form"
import { TagsMultiSelect } from "components/RenderInput"
import { connect } from "react-redux"
import { addAccessTag } from "store/actions"
import { FORM_NAMES } from "constants/index"

const AddUsersByTags = ({
  metaTags,
  vendorId,
  selectedEvent,
  addAccessTag,
  eventInviteListSortOptions,
  initialAccessTags,
  change,
}) => {
  useEffect(() => {
    if (metaTags.length !== 0 && initialAccessTags.length !== 0) {
      change(
        FORM_NAMES.EXPERIENCE,
        "permissions.tags",
        metaTags
          .filter(tag => initialAccessTags.includes(tag.id))
          .map(tag => ({ value: tag.id, label: tag.tag }))
      )
    }
  }, [initialAccessTags, metaTags])

  return (
    <Row className="mt-2">
      <Col xs={12}>
        <h5>
          Add Users by Access Tags -&nbsp;
          <span style={{ fontWeight: "normal" }}>
            Make this experience visible to users by adding access tags
          </span>
        </h5>
      </Col>
      <Col xs={12} md={4} className="mx-3 my-3">
        <Field
          name="tags"
          component={TagsMultiSelect}
          options={metaTags.map(({ id, tag }) => ({
            value: id,
            label: tag,
          }))}
          onChange={(event, newValue, previousValue, name) => {
            addAccessTag(
              {
                event_id: selectedEvent.id,
                tags: newValue ? newValue.map(tag => tag.value) : [],
                type: 1,
                vendor_id: vendorId,
              },
              eventInviteListSortOptions
            )
          }}
        />
      </Col>
    </Row>
  )
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  metaTags: state.Tags.metaTags,
  selectedEvent: state.experiences.selectedEvent,
  eventInviteListSortOptions: state.experiences.eventInviteListSortOptions,
  initialAccessTags: state.experiences.initialAccessTags,
})

const mapDispatchToProps = dispatch => ({
  addAccessTag: (values, sortOptions) =>
    dispatch(addAccessTag(values, sortOptions)),
  change: (form, field, value) => dispatch(change(form, field, value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddUsersByTags)
